import React from "react";

import { Modal } from "@packages/ds";

import * as S from "./ListMode.styles";
import { ProcessesHeaderFullScreen } from "./ProcessesHeaderFullScreen";

export type ListModeProps = {
  children: React.ReactNode;
  setIsFullScreen: (open: boolean) => void;
  fullScreen: boolean;
};

export const ListMode = ({
  fullScreen,
  setIsFullScreen,
  children
}: ListModeProps) =>
  fullScreen ? (
    <Modal.Root open={fullScreen} onOpenChange={setIsFullScreen}>
      <Modal.Portal>
        <S.CustomOverlay />

        <S.CustomContent onOpenAutoFocus={e => e.preventDefault()} width="">
          <ProcessesHeaderFullScreen
            fullScreen={fullScreen}
            setIsFullScreen={setIsFullScreen}
          />
          {children}
        </S.CustomContent>
      </Modal.Portal>
    </Modal.Root>
  ) : (
    <>children</>
  );
